module.exports = __webpack_public_path__ + "static/media/sterling.31c62f61.jpg";